/**
 * Created by luka on 28.02.2018.
 */
import React from 'react';
import DayStateIcon from './DayStateIcon';
import {
	CONFIRMED,
	CURRENT_CONFIRMED,
	CURRENT_PAUSE,
	CURRENT_PENDING,
	MISSED,
	PAUSE,
	PAUSE_CONFIRMED,
	PENDING,
	TOMORROW,
	CHEATED,
	TOMORROW_PAUSE,
	SUSPICIOUS,
} from './DayStates';
import {translate} from 'react-i18next';
import moment from 'moment';
import DayName from './DayName';
import {getTextColor} from './TextColorHelper';
import {ListItem} from 'material-ui/List';
import PauseCircleOutline from "material-ui-icons/PauseCircleOutline";
import {UnfoldMore} from "material-ui-icons";

class DndDayListItem extends React.Component {
	itemSelectable() {
		return [PAUSE, CURRENT_PAUSE].includes(this.props.day.state);
	}

	render() {
		const {state} = this.props.day;
		const classes = [];
		if (this.isToday()) {
			classes.push('active');
		}
		if ([CONFIRMED, CURRENT_CONFIRMED, CURRENT_PAUSE].includes(state)) {
			classes.push('success');
		}
		if (![PAUSE, CURRENT_PAUSE, TOMORROW_PAUSE].includes(state)) {
			classes.push('notSelectable');
		}
		if ([CURRENT_PENDING].includes(state)) {
			classes.push('success-tbd');
		}
		const textColor = this.isToday() ? 'white' : this.props.day.state === PAUSE || this.props.day.state === CURRENT_PAUSE || this.props.day.state === TOMORROW_PAUSE ? '#505050' : '#b0b3b4';

		return (
			<ListItem
				className={`trainingDayWrapper ${classes.join(' ')}`}
				style={{
					borderRadius: 15, // can't target it with css properly.
					cursor: 'pointer',
				}}
				key={this.props.day._id}
				role={undefined}
				button
			>
				<div className={this.isToday() ? 'activeDay' : 'inactiveDay'}>
					<p
						className='dayTitle'
						style={{
							color: textColor,
						}}
					>
						{this.props.t('overview:day').toUpperCase()}
					</p>
					<p
						className='dayDate'
						style={{
							color: textColor,
						}}
					>
						{this.props.day.index}
					</p>
				</div>
				<div className='trainingDayInfo'>
					<p
						className='trainingDayInfoTitle'
						style={{
							color: textColor,
						}}
					>
						{this.getTitleForDayState()}
					</p>
				</div>
				<p
					className='trainingDayInfoDate'
					style={{
						color: textColor,
					}}
				>
					{this.getDate()}
				</p>
				{(this.props.day.state === PAUSE || this.props.day.state === TOMORROW_PAUSE || this.props.day.state === CURRENT_PAUSE) && (
					<UnfoldMore color='primary' style={styles.stateIcon}/>
				)}
				{(this.props.day.state !== PAUSE && this.props.day.state !== TOMORROW_PAUSE && this.props.day.state !== CURRENT_PAUSE) && (
					<div style={styles.stateIconPlaceholder}/>
				)}
			</ListItem>
		);
	}

	getTitleForDayState() {
		switch (this.props.day.state) {
			case PAUSE_CONFIRMED:
			case TOMORROW_PAUSE:
			case CURRENT_PAUSE:
			case PAUSE:
				return this.props.t('overview:rest_day');
			case TOMORROW:
			case MISSED:
			case CURRENT_CONFIRMED:
			case CONFIRMED:
			case CHEATED:
			case SUSPICIOUS:
			case PENDING:
				return this.props.t('overview:workout');
			case CURRENT_PENDING:
				return this.props.t('overview:workout');
			default:
				return '';
		}
	}


	getTimeLeftString() {
		const now = moment(new Date());
		const end = moment(this.props.day.end_deadline);
		const duration = moment.duration(end.diff(now));
		return duration.hours() <= 0
			? this.props.t('common:minute', {count: duration.minutes()})
			: this.props.t('common:hour', {count: duration.hours()});
	}

	isToday() {
		const start = moment(this.props.day.start_deadline);
		return moment(start).isSame(moment(), 'day');
	}

	getDate() {
		if (this.isToday()) {
			return this.props.t('overview:today').toUpperCase();
		} else {
			return moment(this.props.day.start_deadline).format('ddd DD.MM.');
		}
	}
}

const styles = ({
	stateIcon:{
		marginLeft: 20
	},
	stateIconPlaceholder:{
		width: 42
	}
});

export default translate(['overview', 'common'])(DndDayListItem);



// WEBPACK FOOTER //
// ./src/overview/DnDDayListItem.js